/* eslint-disable no-useless-catch */
import { serialize } from 'utils';

import { FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/order-logs';

export const OrderLogApi = {
  findWithEntity: async (
    orderID: string,
    option: FindOrderLogsWithEntityQuery
  ) => {
    let url = `${pathname}/order/${orderID}/entity`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FindOrderLogsWithEntityQuery extends FindOptions {
  editorRole?: string;
  name?: string;
}
